import { getLinkToken, getParameterByName } from './util';

export const isPresentationMode = () => {
    const mode = getParameterByName('mode');
    if (mode && mode.toLowerCase() === 'presentation') {
        return true;
    }

    return false;
};

export const initPresentationViewer = () => {
    if (isPresentationMode()) {
        const recipientsKey = 'recipients=';
        const location = window.location;
        const params = location.search.substr(1).split('&');
        if (params && params.length > 0) {
            const recipientsParam = params.find(p => p.startsWith(recipientsKey));
            const recipients = recipientsParam && recipientsParam.replace(recipientsKey, '');
            if (recipients) {
                // store recipients in sessionStorage so the viewer can still get them after refresh browser
                // and the sessionStorage will be cleared when user close the page
                const linkToken = getLinkToken();
                sessionStorage.setItem(linkToken, recipients);
                // remove the recipients from URL
                const newSearch = params.filter(p => p !== recipientsParam).join('&');
                const newUrl = `${location.origin + location.pathname}?${newSearch}`;
                window.history.replaceState(null, null, newUrl);
            }
        }
    }
};

export const getPresentationAttendees = () => {
    let attendees = '';
    if (isPresentationMode()) {
        const linkToken = getLinkToken();
        attendees = sessionStorage.getItem(linkToken);
    }

    return attendees || '';
};
